import React from 'react';
import { Facebook, Instagram, ExternalLink } from 'lucide-react';
const TiktokIcon = () => <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5" data-id="element-1161" data-mp="31rkkzkjct71b">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.7a8.18 8.18 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.13z" data-id="element-1162" data-mp="31svodj8w0crw" />
  </svg>;
export function SocialFeed() {
  return <section className="w-full py-10 px-4 bg-white/50" data-id="element-1163" data-mp="2j1urr1v8otbi">
      <div className="max-w-6xl mx-auto flex flex-col items-center" data-id="element-1164" data-mp="251abaccsr9l6">
        <h2 className="text-2xl md:text-3xl font-serif text-[#1A1A1A] mb-2" data-id="element-1165" data-mp="2534r5c97obie">
          Följ oss
        </h2>
        <p className="text-[#1A1A1A]/50 text-sm mb-8 text-center max-w-md" data-id="element-1166" data-mp="39f9cogcejg5">
          Håll dig uppdaterad med våra senaste bakverk och nyheter.
        </p>

        <div className="w-full flex flex-col items-center gap-6" data-id="element-1167" data-mp="7ah34prhq3aq">
          {/* Instagram Feed */}
          <div className="flex flex-col items-center w-full max-w-[420px]" data-id="element-1168" data-mp="21jbrf5sj8cwp">
            <div className="flex items-center gap-2 mb-3" data-id="element-1169" data-mp="1wks9dgh27l9m">
              <Instagram className="h-5 w-5 text-[#7C8062]" data-id="element-1170" data-mp="2bapxxxiwiczc" />
              <h3 className="text-lg font-serif text-[#1A1A1A]" data-id="element-1171" data-mp="2b9y3wr4ycnb6">Instagram</h3>
            </div>

            <div className="bg-white p-2 rounded-xl shadow-sm border border-[#7C8062]/15 w-full" data-id="element-1172" data-mp="26c4yw1fdxzch">
              <div className="w-full overflow-hidden flex justify-center bg-gray-50 rounded-lg" style={{
              maxHeight: '380px'
            }} data-id="element-1173" data-mp="1imkcf8k0wjyg">
                <iframe src="https://www.instagram.com/top.notch.bakery/embed/" width="400" height="480" style={{
                border: 'none',
                overflow: 'hidden'
              }} scrolling="no" frameBorder="0" allowFullScreen={true} title="Top Notch Bakery Instagram" className="max-w-full" data-id="element-1174" data-mp="1sljbbzezl189" />
              </div>
            </div>

            <a href="https://www.instagram.com/top.notch.bakery" target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex items-center gap-2 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#7C8062] transition-colors" data-id="element-1175" data-mp="3g14z49iofo60">
              <span data-id="element-1176" data-mp="2sbkgjrqfqsx9">Besök Instagram-profil</span>
              <ExternalLink className="h-3.5 w-3.5" data-id="element-1177" data-mp="2scdblvg17tzk" />
            </a>
          </div>

          {/* Facebook & TikTok Links */}
          <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-1178" data-mp="321ww15je7vwj">
            <div className="flex flex-col items-center" data-id="element-1179" data-mp="32381d9shlbpr">
              <div className="flex items-center gap-2 mb-3" data-id="element-1180" data-mp="24naxgxklwj9t">
                <Facebook className="h-5 w-5 text-[#7C8062]" data-id="element-1181" data-mp="24konyse5ntoy" />
                <h3 className="text-lg font-serif text-[#1A1A1A]" data-id="element-1182" data-mp="29k1bzggrj6t4">Facebook</h3>
              </div>
              <a href="https://www.facebook.com/p/Top-Notch-Bakery-100063945724298/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 px-6 py-3 bg-white rounded-xl shadow-sm border border-[#7C8062]/15 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#7C8062] hover:border-[#7C8062]/30 transition-colors" data-id="element-1183" data-mp="qpy79wmkw5ll">
                <span data-id="element-1184" data-mp="7tqazibjn52f">Följ oss på Facebook</span>
                <ExternalLink className="h-3.5 w-3.5" data-id="element-1185" data-mp="30nbktk351eb" />
              </a>
            </div>

            <div className="flex flex-col items-center" data-id="element-1186" data-mp="3v46c2tg438u1">
              <div className="flex items-center gap-2 mb-3" data-id="element-1187" data-mp="3v2lm7h4qse2i">
                <TiktokIcon data-id="element-1188" data-mp="3q6wh6y9ye4yt" />
                <h3 className="text-lg font-serif text-[#1A1A1A]" data-id="element-1189" data-mp="3q3ie1ntgtrqb">TikTok</h3>
              </div>
              <a href="https://www.tiktok.com/@topnotchbakery" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 px-6 py-3 bg-white rounded-xl shadow-sm border border-[#7C8062]/15 text-sm font-medium text-[#1A1A1A]/70 hover:text-[#7C8062] hover:border-[#7C8062]/30 transition-colors" data-id="element-1190" data-mp="3l5qq14vxypre">
                <span data-id="element-1191" data-mp="1acenxvp2fur8">Följ oss på TikTok</span>
                <ExternalLink className="h-3.5 w-3.5" data-id="element-1192" data-mp="1fd2g4kp16hn1" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}